import { createReducer, on } from "@ngrx/store";
import { Feedback } from "../../../shared/models/feedback.model";
import * as FeedbackActions from './feedback.actions';
import { FeedbackCategory } from "../../../shared/enums/feedback-category.enum";

export interface FeedbackFilterMap {
  is_suggestion_done: boolean | null;
  category: FeedbackCategory | null;
  recipeOnly: boolean;
}

export interface FeedbackState {
  feedbacks: Feedback[];
  isLoading: boolean;
  error: any;
  filters: FeedbackFilterMap;
  searchTerm: string;
}

export const initialState: FeedbackState = {
  feedbacks: [],
  isLoading: false,
  error: null,
  filters: {
    is_suggestion_done: false, // default to only show open ones
    category: null,
    recipeOnly: false
  },
  searchTerm: ''
};

export const feedbackReducer = createReducer(
  initialState,

  // Load all feedbacks
  on(FeedbackActions.loadFeedbacks, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(FeedbackActions.loadFeedbacksSuccess, (state, { feedbacks }) => ({
    ...state,
    feedbacks,
    isLoading: false
  })),
  on(FeedbackActions.loadFeedbacksFailure, (state, { error }) => ({
    ...state,
    error,
    isLoading: false
  })),

  // Create feedback
  on(FeedbackActions.createFeedback, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(FeedbackActions.createFeedbackSuccess, (state, { feedback }) => ({
    ...state,
    feedbacks: [feedback, ...state.feedbacks],
    isLoading: false
  })),
  on(FeedbackActions.createFeedbackFailure, (state, { error }) => ({
    ...state,
    error,
    isLoading: false
  })),
  //Update feedback
  on(FeedbackActions.updateFeedback, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(FeedbackActions.updateFeedbackSuccess, (state, { feedback }) => ({
    ...state,
    feedbacks: state.feedbacks.map(f =>
        f.feedback_id === feedback.feedback_id ? feedback : f
    ),
    isLoading: false,
  })),

  on(FeedbackActions.updateFeedbackFailure, (state, { error }) => ({
    ...state,
    error,
    isLoading: false,
  })),

  // Delete feedback
  on(FeedbackActions.deleteFeedback, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(FeedbackActions.deleteFeedbackSuccess, (state, { id }) => ({
    ...state,
    feedbacks: state.feedbacks.filter(f => f.feedback_id !== id),
    isLoading: false
  })),
  on(FeedbackActions.deleteFeedbackFailure, (state, { error }) => ({
    ...state,
    error,
    isLoading: false
  })),
  // Filter
  on(FeedbackActions.setFeedbackFilters, (state, { filters }) => ({
  ...state,
  filters
})),

on(FeedbackActions.clearFeedbackFilters, (state) => ({
  ...state,
  filters: {
    is_suggestion_done: null,
    category: null
    ,recipeOnly: false
  }
})),

on(FeedbackActions.resetFeedbackFilters, (state) => ({
  ...state,
  filters: {
    is_suggestion_done: false,
    category: null,
    recipeOnly: false
  }
})),

on(FeedbackActions.updateFeedbackSearchTerm, (state, { term }) => ({
  ...state,
  searchTerm: term
})),

on(FeedbackActions.resetFeedbackSearchTerm, (state) => ({
  ...state,
  searchTerm: ''
})),
  on(FeedbackActions.resetFeedbacks, () => initialState)
);